import { useState } from 'react'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import BrechasList from '../components/brechas/BrechasList'

const BrechasTestPage = () => {
  const navigate = useNavigate()
  const [criterioId, setCriterioId] = useState(1) // Default to criterio 1 for testing

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Volver</span>
          </button>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Prueba de Gestión de Brechas
          </h1>
          <p className="text-gray-600">
            Esta es una página de prueba para ver la funcionalidad de brechas implementada en la Fase 1
          </p>
        </div>

        {/* Criterio Selector */}
        <div className="card mb-6">
          <h2 className="text-lg font-semibold mb-4">Seleccionar Criterio</h2>
          <div className="flex items-center space-x-4">
            <label className="text-sm font-medium text-gray-700">
              Criterio ID:
            </label>
            <input
              type="number"
              min="1"
              value={criterioId}
              onChange={(e) => setCriterioId(parseInt(e.target.value))}
              className="input-field w-32"
            />
            <p className="text-sm text-gray-500">
              (Cambia el ID para ver brechas de diferentes criterios)
            </p>
          </div>
        </div>

        {/* Info Card */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h3 className="font-semibold text-blue-900 mb-2">
            🎯 Funcionalidades Implementadas:
          </h3>
          <ul className="text-sm text-blue-800 space-y-1">
            <li>✅ Registrar nuevas brechas con título, descripción y severidad</li>
            <li>✅ Ver lista de brechas por criterio</li>
            <li>✅ Estado vacío positivo cuando no hay brechas</li>
            <li>✅ Tarjetas visuales con colores según severidad</li>
            <li>✅ Validación de formularios</li>
            <li>✅ Contador de caracteres</li>
          </ul>
        </div>

        {/* Brechas List Component */}
        <div className="card">
          <BrechasList criterioId={criterioId} />
        </div>

        {/* Instructions */}
        <div className="mt-6 bg-gray-50 border border-gray-200 rounded-lg p-4">
          <h3 className="font-semibold text-gray-900 mb-2">
            📝 Cómo probar:
          </h3>
          <ol className="text-sm text-gray-700 space-y-2 list-decimal list-inside">
            <li>Haz clic en "Registrar Brecha" para crear una nueva brecha</li>
            <li>Completa el formulario con título, descripción y selecciona la severidad</li>
            <li>Observa cómo la brecha aparece en la lista con colores según severidad</li>
            <li>Cambia el Criterio ID arriba para ver brechas de otros criterios</li>
            <li>Si no hay brechas, verás un mensaje positivo en verde</li>
          </ol>
        </div>

        {/* Next Steps */}
        <div className="mt-6 bg-purple-50 border border-purple-200 rounded-lg p-4">
          <h3 className="font-semibold text-purple-900 mb-2">
            🚀 Próximos pasos (Fase 2):
          </h3>
          <ul className="text-sm text-purple-800 space-y-1">
            <li>• Hacer clic en una brecha para ver su detalle</li>
            <li>• Iniciar ciclos PDCA para documentar mejoras</li>
            <li>• Subir evidencias por cada fase (Planificar, Hacer, Verificar, Actuar)</li>
            <li>• Ver timeline de ciclos de mejora</li>
            <li>• Actualizar estado de brechas (abierta → en proceso → resuelta)</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default BrechasTestPage
